import Backbone from 'backbone';
import template from './segment-alert.pug';

export default class View extends Backbone.View {
  get events() {
    return {
      'click input.btn-default': '_ok',
    };
  }

  _ok() {
    this.trigger('ok');
  }

  render({
    segType,
    i18n,
  }) {
    this.$el.html(template({
      i18n,
      segmentationType: segType,
    }));

    return this;
  }
}
